// Test IDs for the home / landing feature. Naming follows the directive
// in ./auth.js (keys camelCase, values kebab-case `<feature>-<element>`).

export const HOME = {
        emergentLink: 'home-emergent-link',
        heroHeadline: 'home-hero-headline',
        heroDonateButton: 'home-hero-donate-button',
        heroShareButton: 'home-hero-share-button',
        heroMerchButton: 'home-hero-merch-button',
        missionStatement: 'home-mission-statement',
        mentalHealthSection: 'home-mental-health-section',
        ctaDonateButton: 'home-cta-donate-button',
        ctaShareButton: 'home-cta-share-button',
        ctaMerchButton: 'home-cta-merch-button',
        ctaEmailInput: 'home-cta-email-input',
        ctaEmailSubmit: 'home-cta-email-submit',
        ctaEmailSuccess: 'home-cta-email-success',
        shareTwitter: 'home-share-twitter-button',
        shareFacebook: 'home-share-facebook-button',
        shareCopyLink: 'home-share-copy-link-button',
        explainerVideo: 'home-explainer-video',
        explainerDonateButton: 'home-explainer-donate-button',
        getInvolvedButton: 'home-get-involved-button',
};
